module.exports = __webpack_public_path__ + "static/img/co9.ed7407f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperation/co9.jpg
// module id = S17j
// module chunks = 11